"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringBuilder = void 0;
class StringBuilder {
    constructor() {
        this._strings = [];
        this._separator = '';
    }
    withSeparator(separator) {
        this._separator = separator;
        return this;
    }
    append(value) {
        this._strings.push(value);
        return this;
    }
    toString() {
        return this._strings.join(this._separator);
    }
}
exports.StringBuilder = StringBuilder;
